//=====================================================
//　新規予約情報
//=====================================================
import { useState } from "react";
import { ReservationType } from "./ConstCommon";

//新規予約情報IF
export interface IFDataNewReservation {
    done?: boolean,
    date?: Date,
    beforeDate?: string,
    medicalTypeId?: string,
    menu?: string,
    menutime?: number,
    doctor?: string,
    name?: string,
    tel?: string,
    telPrivate?: string,
    email?: string,
    birthday?: string,
    symptoms?: string,
    reserveId?: string,
}

//新規予約情報初期値定数
export const InitDataNewReservation:IFDataNewReservation = {
    done: false,
    date: undefined,
    beforeDate: "",
    medicalTypeId: "",
    menu: "",
    menutime: 0,
    doctor: "",
    name: "",
    tel: "",
    telPrivate: "",
    email: "",
    birthday: "",
    symptoms: "",
    reserveId: "",
}

//新規予約情報管理IF
export interface IFUseNewReservation {
    type: ReservationType,
    data: IFDataNewReservation,
    create: (val: ReservationType, updateVal?: IFDataNewReservation) => void,
    update: (val: IFDataNewReservation, createData?: IFDataNewReservation) => void,
}

//-----------------------------------------------------
//　新規予約情報管理
//-----------------------------------------------------
export function useNewReservation():IFUseNewReservation{

    const [type, setType] = useState(ReservationType.None);
    const [data, setData] = useState<IFDataNewReservation>(InitDataNewReservation);

    //-----------------------------------------------------
    //　予約情報作成（初期化）
    //　初期化時に設定したい項目があれば第2引数に設定する
    //-----------------------------------------------------
    function create(val: ReservationType, updateVal?: IFDataNewReservation){
        setType(val);
        let newData = Object.assign({}, InitDataNewReservation);
        setData(newData);
        if (updateVal){
            update(updateVal, newData);
        }
    }

    //-----------------------------------------------------
    //　更新
    //-----------------------------------------------------
    function update(val: IFDataNewReservation, createData?: IFDataNewReservation){
        let newData:IFDataNewReservation;
        if (createData){
            newData = Object.assign({}, createData);
        } else {
            newData = Object.assign({}, data);
        }
        if (val.done){newData.done = val.done};
        if (val.date){newData.date = val.date};
        if (val.beforeDate){newData.beforeDate = val.beforeDate};
        if (val.medicalTypeId){newData.medicalTypeId = val.medicalTypeId};
        if (val.menu){newData.menu = val.menu};
        // 0の場合も更新する
        if (val.menutime !== undefined){newData.menutime = val.menutime};
        if (val.doctor){newData.doctor = val.doctor};
        if (val.name){newData.name = val.name};
        if (val.tel !== undefined){newData.tel = val.tel};
        if (val.telPrivate !== undefined){newData.telPrivate = val.telPrivate};
        if (val.email !== undefined){newData.email = val.email};
        if (val.birthday){newData.birthday = val.birthday};
        if (val.symptoms !== undefined){newData.symptoms = val.symptoms};
        if (val.reserveId){newData.reserveId = val.reserveId};
        setData(newData);
    }

    return { type, data, create, update }

}